module.exports = __webpack_public_path__ + "img/palette.77952b6d.png";